import { ModernNotification } from './NotificationTypes';

interface NotificationItemProps {
  notification: ModernNotification;
  onMarkAsRead: (id: string) => void;
  onDelete?: (id: string) => void;
}

const NotificationItem = ({ notification, onMarkAsRead, onDelete }: NotificationItemProps) => {
  const handleClick = () => {
    if (!notification.read) {
      onMarkAsRead(notification.id);
    }
    
    // Navigate to action URL if provided
    if (notification.actionUrl) {
      window.location.href = notification.actionUrl;
    }
  };

  const getTimeAgo = (timestamp: Date) => {
    const now = new Date();
    const diff = now.getTime() - timestamp.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) {
      return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
    } else {
      return `${days} day${days !== 1 ? 's' : ''} ago`;
    }
  };

  return (
    <a 
      className="tw-flex tw-items-start tw-gap-3 tw-p-4 hover:tw-bg-gray-50 tw-cursor-pointer tw-no-underline"
      href="#"
      onClick={(e) => {
        e.preventDefault();
        handleClick();
      }}
    >
      {notification.icon && (
        <span className={`material-symbols-outlined tw-mt-1 ${notification.iconColor || 'tw-text-gray-500'}`}>
          {notification.icon}
        </span>
      )}
      <div className="tw-flex-1">
        <p className="tw-text-sm tw-text-gray-800 tw-mb-1">
          <strong>{notification.title}:</strong> {notification.message}
        </p>
        <p className="tw-text-xs tw-text-gray-500">
          {getTimeAgo(notification.timestamp)}
        </p>
      </div>
      {onDelete && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete(notification.id);
          }}
          className="tw-text-gray-400 hover:tw-text-gray-600 tw-ml-2"
          title="Delete notification"
        >
          <span className="material-symbols-outlined tw-text-base">close</span>
        </button>
      )}
    </a>
  );
};

export default NotificationItem;